import React from "react";
import { useTranslation } from "react-i18next";
import type { TransformedProduct } from "../../types/productApiTypes";

// --- Simplified Props ---
interface DetailsActionsProps {
  product: TransformedProduct;
  showViewDetailsButton?: boolean; // Controls visibility of the button
  containerClassName?: string;
}

// --- Simplified DetailsActions Component ---
const DetailsActions: React.FC<DetailsActionsProps> = ({
  product,
  showViewDetailsButton = false, // Default to false
  containerClassName = "details-actions-container", // Default class
}) => {
  const { t } = useTranslation();

  // If there's no button to show, render nothing.
  if (!showViewDetailsButton) {
    return null;
  }

  // --- Render ---
  return (
    <div className={containerClassName}>
      <div className="details-actions-row">
        {/* --- "View Full Details" Button --- */}
        {showViewDetailsButton && (
          <a href={product.permalink} className="view-details-button">
            {t("productModal.viewDetails", "View Full Details")}
          </a>
        )}
      </div>
    </div>
  );
};

export default DetailsActions;
